export interface PackageInfo {
  id: string;
  name: string;
  price: string;
  credits: number;
  perCredit: string;
  popular?: boolean;
  hidden?: boolean;
  features: string[];
}

const ALL_PACKAGES: PackageInfo[] = [
  {
    id: "starter",
    name: "Starter",
    price: "$49",
    credits: 400,
    perCredit: "$0.12",
    features: ["All creation tools", "Standard & Premium quality", "Stars never expire"],
  },
  {
    id: "creator",
    name: "Creator",
    price: "$99",
    credits: 1100,
    perCredit: "$0.09",
    popular: true,
    features: ["2.75x more stars", "All creation tools", "Best value for hobbyists"],
  },
  {
    id: "pro",
    name: "Pro",
    price: "$199",
    credits: 2400,
    perCredit: "$0.08",
    features: ["6x more stars", "Bulk creation power", "Great for projects"],
  },
  {
    id: "studio",
    name: "Studio",
    price: "$399",
    credits: 4500,
    perCredit: "$0.09",
    hidden: true,
    features: ["11x more stars", "Production-level volume", "Ideal for teams"],
  },
  {
    id: "scale",
    name: "Scale",
    price: "$799",
    credits: 10000,
    perCredit: "$0.08",
    hidden: true,
    features: ["25x more stars", "Maximum volume", "Lowest cost per star"],
  },
];

export const CREDIT_PACKAGES = ALL_PACKAGES.filter((p) => !p.hidden);

export const DODO_PRODUCT_IDS: Record<string, string> = {
  starter: "pdt_0Naif6RoTWRW624KdNc15",
  creator: "pdt_0NaigAhCLTBa3fo6ALZb9",
  pro: "pdt_0NaigY3kiEzzvGMR4mOxQ",
};
